import React, { useState } from "react";
import axios from "axios";
import "./login.scss";
import logo from "../../assets/fitoja-logo.jpg";
import { useNavigate } from "react-router-dom";
import eyeIconCross from "../../assets/eye_icon_cross.png";
import eyeIcon from "../../assets/eye_icon.png";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://api.fitoja.in/api/login-admin-panel",
        {
          email,
          password,
        }
      );
      const { token } = response.data;
      localStorage.setItem("email", email);
      localStorage.setItem("token", token);
      navigate("/dashboard");
    } catch (err) {
      setError("Invalid email or password");
      console.error(err);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        {/* Left Side */}
        <div className="login-left">
          <img src={logo} alt="Fitoja Logo" className="logo" />
          <h1>Welcome to</h1>
          <h1>Fitoja Admin Panel</h1>
        </div>

        {/* Right Side */}
        <div className="login-right">
          {error && <p className="error-message">{error}</p>}
          <form onSubmit={handleSubmit}>
            <div className="input-container">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="input-container password-container">
              <input
                type={showPassword ? "text" : "password"} // Toggle password visibility
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="eye-icon-btn"
                onClick={togglePasswordVisibility}
              >
                <img
                  className="eye-icon-img"
                  src={showPassword ? eyeIconCross : eyeIcon}
                  alt="Toggle Password Visibility"
                />
              </button>
            </div>
            <button type="submit" className="login-btn">
              Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
